export function getPageTitle(pageTitle, title = '同等学力学习系统') {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
